import Button from '../button/button';
import { DomElementAlignment, DomTargetPosition } from '../enums';
import TooltipLegacy from '../tooltip-component/tooltip.component';
import type { DynamicFormButtonSetting } from './dynamic-form.interfaces';

const MAX_DISPLAY_LENGTH = 24;
const TRUNCATED_LENGTH = 21;

interface DynamicFormButtonProps {
  button: DynamicFormButtonSetting;
  readOnly?: boolean;
  fullWidth?: boolean;
}

const DynamicFormButton = ({ button, readOnly, fullWidth = false }: DynamicFormButtonProps) => {
  const fullText = button.text;
  const showTooltip = fullText.length > MAX_DISPLAY_LENGTH;
  const displayText = showTooltip ? `${fullText.substring(0, TRUNCATED_LENGTH)}...` : fullText;
  const disabled = button.disabled === undefined ? readOnly : button.disabled;

  return (
    <Button
      fullWidth={fullWidth}
      htmlType={button.htmlType}
      type={button.type}
      variant={button.variant}
      classNames={button.className}
      disabled={disabled}
      hidden={button.hidden}
      onClick={button.onClick}
    >
      <TooltipLegacy
        description={fullText}
        tooltipClassName="bg-mono-1"
        disabled={!showTooltip}
        tooltipZIndexCheck={true}
        tooltipTargetPosition={DomTargetPosition.TopRight}
        tooltipAlignment={DomElementAlignment.TopRight}
      >
        {displayText}
      </TooltipLegacy>
    </Button>
  );
};

export default DynamicFormButton;
